import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import { getAppOriginAndTimezone } from '../../../Utils/getAppOrigin';
import { toast } from 'react-toastify';

const AdminDisplayLifecycle = {
  name: 'adminDisplayLifecycle',
  state: {
    restoreLoading: false,
    deleteImpactLoading: false,
    deleteLoading: false,
    deleteImpact: null,
    error: '',
  },
  reducers: {
    restoreRequested(state) {
      return { ...state, restoreLoading: true, error: '' };
    },
    restoreDone(state) {
      return { ...state, restoreLoading: false, error: '' };
    },
    impactRequested(state) {
      return { ...state, deleteImpactLoading: true, error: '' };
    },
    impactReceived(state, payload) {
      return { ...state, deleteImpactLoading: false, deleteImpact: payload, error: '' };
    },
    deleteRequested(state) {
      return { ...state, deleteLoading: true, error: '' };
    },
    deleteDone(state) {
      return { ...state, deleteLoading: false, error: '' };
    },
    requestFailed(state, payload) {
      return {
        ...state,
        restoreLoading: false,
        deleteImpactLoading: false,
        deleteLoading: false,
        error: payload,
      };
    },
    clearImpact(state) {
      return { ...state, deleteImpact: null };
    },
  },
  effects: (dispatch) => ({
    async restoreDisplay(displayId) {
      try {
        this.restoreRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const { origin, timezone } = getAppOriginAndTimezone();
        const response = await http.put(
          `savvy/displays/admin/restore/${displayId}`,
          {
            user_id: userInfo?.id,
            org_id: userInfo?.org_id,
            origin,
            timezone,
          }
        );
        this.restoreDone();
        toast.success(response?.data?.message || 'Display restored successfully');
        return { success: true, data: response?.data };
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Failed to restore display';
        this.requestFailed(msg);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(msg),
            show: true,
          },
        });
        return { success: false, error: msg };
      }
    },
    async getDeleteImpact(displayId) {
      try {
        this.impactRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const response = await http.get(
          `savvy/displays/admin/delete-impact/${displayId}?org_id=${userInfo?.org_id}`
        );
        this.impactReceived(response?.data?.data || response?.data || null);
        return { success: true, data: response?.data?.data || response?.data || null };
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Failed to fetch delete impact';
        this.requestFailed(msg);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(msg),
            show: true,
          },
        });
        return { success: false, error: msg };
      }
    },
    async permanentDeleteDisplay(displayId) {
      try {
        this.deleteRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const { origin, timezone } = getAppOriginAndTimezone();
        const params = new URLSearchParams({
          user_id: String(userInfo?.id ?? ''),
          org_id: String(userInfo?.org_id ?? ''),
          origin,
          timezone,
        });
        const response = await http.delete(
          `savvy/displays/admin/permanent-delete/${displayId}?${params}`
        );
        this.deleteDone();
        toast.success(response?.data?.message || 'Display permanently deleted');
        return { success: true, data: response?.data };
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Failed to permanently delete display';
        this.requestFailed(msg);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(msg),
            show: true,
          },
        });
        return { success: false, error: msg };
      }
    },
  }),
};

export default AdminDisplayLifecycle;
